import { createReducer, on } from '@ngrx/store';
import { Brand} from '../../models/dbmodels';
import * as BrandActions from './brands.actions';

export const BrandsFeatureKey = 'brands';

export interface BrandState {
  brands: Brand[];
  loaded: boolean;
  error: string | null;
}

export const initialBrandState: BrandState = {
  brands: [],
  loaded: false,
  error: null,
};

export const brandsReducer = createReducer(
  initialBrandState,
  on(BrandActions.loadBrands, (state) => ({
    ...state,
    loaded: false,
    error: null
  })),
  on(BrandActions.loadBrandsSuccess, (state, { brands }) => ({
    ...state,
    brands: brands,
    loaded: true,
    error: null
  })),
  on(BrandActions.loadBrandsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error
  }))
);
